import { render, staticRenderFns } from "./DashboardSuperAdmin.vue?vue&type=template&id=d39d3d5c&"
import script from "./DashboardSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardSuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSuperAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports